import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import vector from "../../../../../assets/images/meetupEvent/Vector.png";
// import clock from "../../../../../assets/images/meetupEvent/clock-icon.png";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import swal from "sweetalert";

import flag from "../../../../../assets/images/flag.png";
import flag4 from "../../../../../assets/images/Interval-01.1.png";
import flag2 from "../../../../../assets/images/Maximum-Time-01.1.png";
import clock from "../../../../../assets/images/meetupEvent/clock.png";
import flag3 from "../../../../../assets/images/Minimum-Time-01.1.png";
import flag1 from "../../../../../assets/images/Registration-End-01.1.png";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../HelperComponent/ContdownTimerRender";

const EventSlot = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const [event, setEvent] = useState("");
  const [slot, setSlot] = useState([]);
  const [withSlot, setWithSlot] = useState([]);
  const [eventTime, setEventTime] = useState([]);
  const [slotBuffer, setSlotBuffer] = useState(false);

  const event_id = props.match.params.id;
  useEffect(() => {

    axios.get(`/api/admin/live-chat/details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.event);
        setEventTime(res.data.event?.event_date);
      }
    });
    getAllRegUser()

  }, [props.match.params.slug, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/approveMeetup/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/learning-session/approved");
        }
      });
    });
  };

  const getAllRegUser = () => {
    setSlot([]);
    setWithSlot([])
    axios
      .get(`/api/admin/live-chat/registered_user_list/${event_id}`)
      .then((res) => {
        if (res?.data?.status === 200) {
          setSlot(res?.data?.users);
          setWithSlot(res?.data?.withOutSlotUser)
          console.log('all regiosteer------->', res.data.users)
        }
      });
  }

  const handelSlotAlocation = () => {
    setSlotBuffer(true)
    axios
      .get(`/api/time-distribute/${event_id}`)
      .then((res) => {
        setSlotBuffer(false)
        if (res.data.status === 200) {
          getAllRegUser()
        }
      }).catch((err) => {
        setSlotBuffer(false)
      });
  }

  const joinRoute = () => {
    history.push({
      pathname: `/superstar-admin/callDetails`,
      state: { event_id: event.id, slot: slot, from: "star" },
    });
    // window.location.href = `/superstar-admin/live-chat/stream/${event.slug};
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/rejectMeetup/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar/learning-session/pending");
        }
      });
    });
  };

  const event_start = new Date(
    moment(eventTime).format("LL") + " " + event.start_time
  ).getTime();

  const event_end = new Date(
    moment(eventTime).format("LL") + " " + event.end_time
  ).getTime();


  return (
    <div className="container-fluid">
      {Number(event.status) > 0 ? (
        <>
          <div className="row">
            <div className="col-md-6">
              <div className="card card-bg p-3 mb-3">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="Banner-SME-b"
                />
   
            <Countdown
              date={event_start}
              renderer={ContdownTimerRender}
            />
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div className="row">
                <div className="registration-head  card-bg mb-1">
                  <h5 className="text-warning fw-bold p-2">Registration </h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Start:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag1} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration End:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag2} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Maximum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.max_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag3} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Minimum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.min_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Interval:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.interval} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Fee:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          ${event.fee}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="card card-bg p-3">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid Banner-SME-b"
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="registration-head  card-bg mb-1">
                  <h5 className="text-warning fw-bold p-2">Registration </h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Start:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag1} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration End:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag2} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Maximum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.max_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag3} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Minimum Time:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.min_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Interval:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.interval} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Fee:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.fee} $
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 my-3">
            <div className="card card-bg shadow d-flex justify-content-center align-items-center">
              <img src={clock} className="img-fluid p-3" alt="" />

              <h2 className="text-warning">Event Details submitted</h2>
              <p className="text-light">
                Waiting for &nbsp;
                {event.star_approve_status === 1 ? (
                  <span className="fw-bold">Manager Admin</span>
                ) : (
                  <span className="fw-bold">SuperStar</span>
                )}
                &nbsp; Approval
              </p>
            </div>
          </div>
        </>
      )}

      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h5 className="text-light pb-3">{event.title}</h5>

              <h5 className="text-warning">Instruction</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={event.instruction} />
              </p>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={event.description} />
              </p>

              <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                <h5 className="text-warning pt-2 ">Event Date</h5>
                <p className="text-light fw-bold pt-2">
                  {moment(event.event_date).format("LL")} |{" "}
                  {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                  {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className="btn btnJoinNow MEN-X fw-bold px-5 mt-3"
        onClick={handelSlotAlocation}
      >
        {slotBuffer ?
          <div class="spinner-border text-warning" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          :

          "Distribute Slot"
        }
      </button>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="card card-bg solt-card">
            <div className="card-body">
              <h3 className="text-warning">
                <img src={vector} alt="clock" className="mx-2"></img>
                Request For Time Slot ({withSlot.length})
              </h3>
              <div className="row my-3">
                {withSlot && withSlot.map((user, index) => (
                  <div className="col-md-2 col-sm-3 ">
                    <p className="sold-small-card fw-bold">
                      <img
                        src={imageCdnUrl + user.user?.image}
                        className="img-fluid mx-2 p-1"
                        alt=""
                        style={{ height: "50px", width: "50px" }}
                      />
                      {user.user?.first_name} {user.user?.last_name} ({user?.taken_time} m)
                      <br />
                      <small style={{ marginLeft: '20%' }}>
                        Phone - {user?.user?.phone}
                      </small>
                      
                    </p>
                    
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-4">
          <div className="card card-bg solt-card">
            <div className="card-body">
              <h3 className="text-warning">
                <img src={vector} alt="clock" className="mx-2"></img>
                Slot Allocated ({slot.length})
              </h3>
              <div className="row my-3">
                {slot && slot.map((user, index) => (
                  <div className="col-md-2 col-sm-3 ">
                    <p className="sold-small-card fw-bold">
                      <img
                        src={imageCdnUrl + user.user?.image}
                        className="img-fluid mx-2 p-1"
                        alt=""
                        style={{ height: "50px", width: "50px" }}
                      />



                      {user.user?.first_name} {user.user?.last_name}
                      <br />
                       <small style={{ marginLeft: '10%' }}>
                        Phone - {user?.user?.phone}
                      </small>
                      <br />

                      <small style={{ marginLeft: '10%' }}>

                        ( {user?.taken_time} m )
                        {" " + moment(user?.live_chat_date + " " + user?.live_chat_start_time).format('LT') + " "}
                        -
                        {" " + moment(user?.live_chat_date + " " + user?.live_chat_end_time).format('LT')}
                      </small>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>



        {Number(event.status) === 2 &&
          event_start <= new Date().getTime() &&
          event_end > new Date().getTime() ? (
          <div className="mt-3 d-flex justify-content-center">
            <button
              className="btn btnJoinNow MEN-X fw-bold px-5"
              onClick={joinRoute}
            >
              Join Now
            </button>
          </div>
        ) : Number(event.status) === 2 && event_end < new Date().getTime() ? (
          <div className="mt-3 d-flex justify-content-center">
            <button className="btn btn-info MEN-X fw-bold px-5" disabled>
              Event End
            </button>
          </div>
        ) : Number(event.status) < 1 ? (
          <div className="mt-3 d-flex justify-content-center">
            <button className="btn btnSave MEN-X fw-bold" onClick={handleClick}>
              Approve
            </button>
            <Link to={`/superstar/live-chat/edit/${event.id}`}>
              {" "}
              <button className="btn btnEdit MEN-Y text-warning fw-bold px-3 mx-3">
                Edit
              </button>
            </Link>
            <button
              className="btn MEN-Y btnDecline text-light fw-bold"
              onClick={setReject}
            >
              Reject
            </button>
          </div>
        ) : Number(event.status) === 9 ? (
          <></>
        ) : (
          <div className="mt-3 d-flex justify-content-center">
            <button className="btn btnJoinNow MEN-X fw-bold px-5" disabled>
              Join Now
            </button>
          </div>
        )}
      </div>
    </div >
  );
};

export default EventSlot;
